export default {
  price_calc: 'Price Calculator',
  price_tips:
    'This page only provides an estimated cost, actual prices may vary based on usage.',
  price_simulation: 'Simulation scenario',
  price_service_pur: 'Service Purchase',
  price_simulation_tips:
    'The estimated price will be based on the data performance after the game goes live. Please note that the actual price is not directly calculated from the parameters entered below.',
  price_region: 'Region',
  price_game_type: 'Game Type',
  price_players_num: 'Total Players',
  price_btn_calc: 'Calculate',
  price_btn_calc_re: 'Re-estimate',
  price_cost_tips:
    'Actual consumption will depend on usage and may be lower than this estimated price. This data is for reference only.',
  price_estimated_cost: 'Estimated cost',
  price_view_detail: 'View Details',
  price_pack_up_detail: 'Close Details',
  price_service: 'Service',
  price_estimated: 'Estimated Price',
  price_description: 'Description',
  price_subscription_fees: 'Subscription Fees',
  price_subscription_fees_tips:
    'The subscription fee includes a certain amount of free usage for various online services.If none of the selected services have a free usage quota, this subscription fee does not apply.',
  price_multiplayer: 'Multiplayer',
  price_player: 'Player',
  price_party: 'Party',
  price_lobby: 'Lobby',
  price_matchmaking: 'Matchmaking',
  price_microservice: 'Microservice',
  price_goals: 'Goals',
  price_ds_hosting: 'DS Hosting',
  price_social: 'Social',
  price_friends: 'Friends',
  price_text_chat: 'Text Chat',
  price_voice_chat: 'Voice Chat(GVoice)',
  price_guild: 'Guild',
  price_leaderboards: 'Leaderboards',
  price_economy: 'Economy',
  price_game_items: 'Game Items',
  price_store: 'Store(GMall)',
  price_engage: 'Engagement',
  price_mails: 'Mails',
  price_private_access: 'Private Access',
  price_command: 'Command',
  price_analytics: 'Analytics',
  price_dashboard: 'Dashboard',
  price_telemetry: 'Telemetry',
  price_health_monitor: 'Health Monitor',
  price_session_track: 'Session Track',
  price_content: 'Content',
  price_remote_config: 'Remote Config(BianQue)',
  price_content_delivery: 'Content Delivery',
  price_not_support:
    'This service is currently not supported for calculation. Please contact the InGame team for further information.',
  price_additional_services:
    'InGame additional services, after selecting the relevant service, this service is available for free.',
  price_area_cn: 'China',
  price_area_intl: 'International',
  price_moba: 'MOBA',
  price_shooter_games: 'Shooter Games',
  price_rpg: 'RPG',
  price_strategy_games: 'Strategy Games',
  price_card_games: 'Card Games',
  price_simulation_games: 'Simulation Games',
  price_adventure_games: 'Adventure Games',
  price_action_games: 'Action Games',
  price_racing_games: 'Racing Games',
  price_party_games: 'Party Games',
  price_sports_games: 'Sports Games',
  price_casual_games: 'Casual Games',
  price_survival_games: 'Survival Games',
  price_open_world_games: 'Open World Games',
  price_fighting_games: 'Fighting Games',
  price_others: 'Others',
  price_service_tips:
    'Please complete the simulation scenario and select at least one service.',
};
